import React, { useState, useEffect } from "react";
import firebase from "../../services/firebase";
import { v4 as uuidv4 } from "uuid";
import "firebase/storage";
import { Link, useHistory } from "react-router-dom";
import Dashboard from "./Dashboard";
import { useDispatch, useSelector } from "react-redux";
import { getScouts } from "../../actions/surveyActions";
import axiosInstance from "../../services/axiosInstance";
import { APIS } from "../../services/config";

const RequestVideo = ({ location }) => {
  const { request } = location.state || {};
  const [file, setFile] = useState("");
  const [videoUrl, setVideoUrl] = useState("");
  const [videoDuration, setVideoDuration] = useState();
  const [error, setError] = useState("");
  let history = useHistory();

  const fetchScout = useSelector((state) => state.fetchScout);

  const { data: scoutData } = fetchScout;

  const dispatch = useDispatch();

  const getUploadUrl = async (
    mmCampaignRef = request?.mmCampaignRef || request?.requestRef,
    mimeType
  ) => {
    const {
      baseUrl,
      getMultimediaUploadUrl: { path },
    } = APIS;

    const res = await axiosInstance.post(baseUrl + path, {
      mmCampaignRef,
      mimeType,
    });

    return res.data; // { uploadUrl, finalUrl, expiresIn }
  };

  //Video Duration Helper Function
  const loadVideo = (file) =>
    new Promise((resolve, reject) => {
      try {
        let video = document.createElement("video");
        video.preload = "metadata";

        video.onloadedmetadata = function () {
          resolve(this);
        };

        video.onerror = function () {
          reject("Invalid video. Please select a video file.");
        };

        video.src = window.URL.createObjectURL(file);
      } catch (e) {
        reject(e);
      }
    });

  const uploadVideo = async (e) => {
    const selectedFile = e.target.files[0];
    if (!selectedFile) return;

    // Validate MIME type
    const allowedTypes = [
      "video/mp4",
      "video/quicktime", // .mov
      "video/webm",
    ];

    if (!allowedTypes.includes(selectedFile.type)) {
      setError(
        "Unsupported video format. Please upload MP4, MOV, or WebM files only."
      );
      setFile("");
      setVideoUrl("");
      return;
    }

    try {
      const video = await loadVideo(selectedFile);
      const durationMin = video.duration / 60;

      setVideoDuration(durationMin);

      if (durationMin > 0.5) {
        setError(
          "Video is too long. Please upload a video that is 30 seconds or less."
        );
        setFile("");
        setVideoUrl("");
        return;
      }

      setError("");

      // Preview
      const src = URL.createObjectURL(selectedFile);
      setFile(src);

      const mmCampaignRef = request?.requestRef;
      const mimeType = selectedFile.type;

      const { uploadUrl, finalUrl } = await getUploadUrl(
        mmCampaignRef,
        mimeType
      );

      await fetch(uploadUrl, {
        method: "PUT",
        body: selectedFile,
        headers: {
          "Content-Type": mimeType,
        },
      });

      setVideoUrl({ id: mmCampaignRef, url: finalUrl });
    } catch (err) {
      console.error(err);
      setError(err?.message || "Failed to upload video");
      setFile("");
      setVideoUrl("");
    }
  };
  const resetFile = async (e) => {
    e.preventDefault();
    setFile("");
    setVideoUrl("");
    setError("");
  };

  useEffect(() => {
    dispatch(getScouts());
  }, [dispatch]);

  const onSubmit = async (e) => {
    e.preventDefault();

    if (!videoUrl?.url) {
      setError("No video uploaded");
      return;
    }

    try {
      const {
        baseUrl,
        submitMultimediaResponse: { path },
      } = APIS;

      const payload = {
        mmCampaignRef: request?.mmCampaignRef || request?.requestRef,
        responseURL: videoUrl.url,
        // responseURLs: [], // only for multi-file if needed
        optional_message: "", // or bind to a textarea if you want
      };

      const res = await axiosInstance.post(baseUrl + path, payload);

      console.log("res", res);

      if (res?.status === 200) {
        history.push({
          pathname: "/request-submit-success",
          state: { request },
        });
      } else {
        setError(res.data?.message || "Failed to submit response");
      }
    } catch (err) {
      console.error(err);
      setError(err?.response?.data?.message || "Failed to submit response");
    }
  };

  return (
    <div>
      <Dashboard />
      {file === "" ? (
        <div className="modal">
          <Link
            to="/dashboard"
            className="modal-bg w-inline-block"
            style={{ backdropFilter: "blur(16px)" }}
          ></Link>
          <div className="padding-6 background-color-3 radius-large box-shadow-large width-full max-width-xl">
            <div className="modal-section">
              <h5 className="text-color-4 margin-0 weight-normal">
                <strong>{request?.requestName}</strong>
              </h5>
              <div className="padding-top-6 margin-top-6 border-top-2px">
                <div className="upload">
                  <div className="in-upload">
                    You can preview before sending
                  </div>
                </div>
              </div>
            </div>
            <div className="padding-top-6 border-top-2px">
              <label
                htmlFor="formId"
                className="button background-color-brand w-button"
              >
                Upload Video
                <input
                  name=""
                  type="file"
                  id="formId"
                  hidden
                  accept="video/mp4,video/x-m4v,video/*"
                  onChange={uploadVideo}
                />
              </label>
              <p className="text-color-2 margin-top-4 margin-bottom-0 text-small">
                Only <strong>mp4</strong>, <strong>mov</strong> &amp;{" "}
                <strong>webm</strong> files supported. Video must not be longer
                than 30 seconds.
                <br />
              </p>
              {error && (
                <p
                  className="text-small margin-top-4"
                  style={{ color: "#FFCC00" }}
                >
                  {error}
                </p>
              )}
            </div>
          </div>
        </div>
      ) : (
        <div className="modal">
          <Link
            to="/dashboard"
            className="modal-bg w-inline-block"
            style={{ backdropFilter: "blur(16px)" }}
          ></Link>
          <div className="w-embed"></div>

          <form>
            <div className="padding-6 background-color-3 radius-large box-shadow-large width-full max-width-xl">
              <div className="modal-section">
                <h5 className="text-color-4 margin-0 weight-normal">
                  <strong>{request?.requestName}</strong>
                </h5>
                <div className="padding-top-6 margin-top-6 border-top-2px">
                  {/* <div className="upload recording"

                > */}
                  <video
                    className="videoPreview"
                    src={file}
                    controls
                    autoPlay
                    loop
                    muted
                  ></video>
                  {/* <button
                    style={{ position: "relative" }}
                    className="button background-color-brand absolute-bottom-left margin-6 padding-4 background-color-red box-shadow-medium w-button"
                    onClick={resetFile}
                    disabled={videoUrl === "" && videoDuration <= 0.5}
                  >
                    <span data-feater="trash-2" className="icon">
                      Delete
                    </span>
                    </button> */}
                  <button
                    className="button-secondary w-button box-shadow-medium"
                    style={{
                      backgroundColor: "#d32062",
                      color: "white",
                      marginTop: "15px",
                    }}
                    onClick={resetFile}
                    disabled={videoUrl === "" && videoDuration <= 0.5}
                  >
                    Delete
                  </button>
                  {/* </div> */}
                </div>
              </div>
              <div className="padding-top-6 border-top-2px flex-space-between margin-top-6 flex-align-center portrait-flex-column portrait-flex-align-start">
                <p className="text-color-2 margin-top-4">
                  Only &nbsp;<strong>mp4&nbsp;</strong>
                  &amp; <strong>mov</strong> files supported
                  <br />
                  {videoDuration > 0.5 ? (
                    <span style={{ color: " #FFCC00" }}>
                      Video must not be longer than 30 seconds, please upload
                      another video.
                    </span>
                  ) : null}
                  <span style={{ color: " #FFCC00" }}>{error}</span>
                </p>
                <button
                  type="submit"
                  className="button-secondary w-button"
                  disabled={videoDuration > 0.5 || !videoUrl?.url}
                  onClick={onSubmit}
                >
                  {videoUrl?.url ? "Submit" : "Uploading"}
                </button>
              </div>
            </div>
          </form>
        </div>
      )}
    </div>
  );
};

export default RequestVideo;
